import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { useLanguage } from "../Language";

function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="footer-container">
      <div className="footer-inner page-width">
        <div>
          <Link
            to="/"
            className="footer-brand"
            aria-label={t("QUICR – Startseite")}
          >
            <img
              src="/images/logo_offen.png"
              alt=""
              width="1917"
              height="755"
            />
          </Link>
          <p>{t("Digitale Impulse. Echte Bewegung.")}</p>
        </div>
        <nav aria-label={t("Weitere Informationen")}>
          <Link to="/#contact">{t("Kontakt")}</Link>
          <Link to="/datenschutz">{t("Datenschutz")}</Link>
          <Link to="/impressum">{t("Impressum")}</Link>
        </nav>
        <small>
          {t("Ein Label von")}{" "}
          <a
            rel="noreferrer"
            href="https://www.trace-space.com/"
            target="_blank"
          >
            TraceSpace
          </a>
        </small>
      </div>
    </footer>
  );
}
export default Footer;
